/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// import { pxToEm } from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- COMMENTING DIVISION : STYLES --------------- ++++++++++ */
export default theme => ({
    trendingnowv2: {

    }
});
